import Vue from 'vue';
import Errors from '../classes/Errors';

Vue.component('register-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=6LfLeKsfAAAAAFpQJ6V_qZuMwgFg2ktZydaNvFWx')
        document.head.appendChild(recaptchaScript)
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onSubmit(e) {
            e.preventDefault();
            grecaptcha.ready(function() {
              grecaptcha.execute('6LfLeKsfAAAAAFpQJ6V_qZuMwgFg2ktZydaNvFWx', {action: 'submit'}).then(function(token) {
                  // Add your logic to submit to your backend server here.
                  document.getElementById("register-form").submit();
              });
            });
          }
    }
});
